import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'rsuite';

const DisableBackDrop = styled(Row)`
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  color: #f44336;
  font-size: 14px;
  border-radius: 5px;
  > div {
    height: 100%;
  }
  > div:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: #efefef;
  }
  > div:last-child {
    background-color: #ffffffd9;
    z-index: 1;
    padding: 20px;
    border-radius: 5px;
  }
`;

const EventDisabledOverlay = () => (
  <DisableBackDrop>
    <Col xs={24} sm={6} />
    <Col xs={24} sm={18}>
      <b>Ineligible:</b> Guest have reached Tracking Method&apos;s
      visits/reservations limit within the time period.
    </Col>
  </DisableBackDrop>
);

export default EventDisabledOverlay;
